import { BASE_SPEED, SPEED_INCREASE } from "~/src/consts/config";

export interface GhostAI {
	targetPosition: Required<Phaser.Types.Math.Vector2Like>;
	speed: number;

	chooseTarget(
		boardLayer?: Phaser.Tilemaps.TilemapLayer,
		door?: Phaser.GameObjects.Rectangle
	): void
}

export const calculateSpeed = (level) => BASE_SPEED + (level * SPEED_INCREASE);